import Grid from '@material-ui/core/Grid';
import { Theme } from '@material-ui/core/styles/createMuiTheme';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { getStatusLabel, IStatusMetrics } from 'interfaces/dashboard';
import React, { memo } from 'react';

import Card from '../Component/Card';

interface IProps {
  metrics: IStatusMetrics;
}

const DocsActives = memo<IProps>((props) => {
  const { metrics } = props;
  const sm = useMediaQuery((theme: Theme) => theme.breakpoints.only('sm'));

  return (
    <Card
      bgContent
      bgcolor='#161d42'
      height='100%'
      contentProps={{
        height: '100%',
        display: 'flex',
        alignItems: 'center'
      }}
    >
      <Grid container justify="center" alignItems="center" spacing={2} style={{ backgroundColor: '#F7F4FF', borderRadius: '10px' }}>
        <Grid item xs={4} sm={12} lg={4}>
          <Typography
            align={!sm ? 'right' : 'center'}
            variant='h4'
            style={{
              color: '#112734',
              fontWeight: 'bold'
            }}
          >
            {metrics.value}
          </Typography>
        </Grid>
        <Grid item xs>
          <Typography
            align={!sm ? 'left' : 'center'}
            variant='subtitle1'
            color='textSecondary'
            style={{
              lineHeight: 1,
              fontWeight: 'bold',
              color: '#161d42',
            }}
          >
            {getStatusLabel(metrics.status, true)}
          </Typography>
        </Grid>
      </Grid>
    </Card>
  );
});

export default DocsActives;